import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const callRoutes: RouteObject[] = [
  {
    path: '/call-route',
    element: lazyElement(() => import('./route/Main')),
    handle: {
      documentTitle: 'Call Routes',
      crumb: () => ({ label: 'Call Routes', to: '/call-route' })
    },
  },
];

export default callRoutes;
